import { createBrowserRouter } from "react-router-dom";
import { t } from "i18next";
import { lazy } from "react";

// Layouts
const RestrictedLayout = lazy(() => import("layouts/RestrictedLayout"));

// Gateway
const DashboardPage = lazy(() => import("pages/Gateway/DashboardPage"));
const MerchantPage = lazy(() => import("pages/Gateway/MerchantPage"));
const MerchantsPage = lazy(() => import("pages/Gateway/MerchantsPage"));
const MerchantEditPage = lazy(() => import("pages/Gateway/MerchantEditPage"));
const MerchantRegisterPage = lazy(() => import("pages/Gateway/MerchantRegisterPage"));
const PaymentPage = lazy(() => import("pages/Gateway/PaymentPage"));
const PaymentsPage = lazy(() => import("pages/Gateway/PaymentsPage"));
const TransactionPage = lazy(() => import("pages/Gateway/TransactionPage"));

const RefundTransactionPages = lazy(() => import("pages/Gateway/RefundTransactionPages"));

const routeItems = [
  {
    element: <RestrictedLayout />,
    children: [
      { key: "home", path: "", element: <MerchantsPage /> },

      {
        key: "gateway",
        path: "gateway",
        children: [
          {
            key: "gateway.dashboard",
            path: "dashboard",
            element: <DashboardPage />,
          },

          {
            key: "gateway.merchants",
            path: "merchants",
            element: <MerchantsPage />,
          },
          {
            key: "gateway.merchant",
            path: "merchants/:merchantID",
            element: <MerchantPage />,
          },
          {
            key: "gateway.merchant.create",
            path: "merchants/create",
            element: <MerchantRegisterPage />,
          },
          {
            key: "gateway.merchant.edit",
            path: "merchants/:merchantID/edit",
            element: <MerchantEditPage />,
          },

          {
            key: "gateway.payments",
            path: "payments",
            element: <PaymentsPage />,
          },
          {
            key: "gateway.payment",
            path: "payments/:paymentID",
            element: <PaymentPage />,
          },
          {
            key: "gateway.payment.detail",
            path: "payment/:paymentID/detail",
            element: <PaymentPage />,
          },
          {
            key: "gateway.payment.transaction.detail",
            path: "payment/:paymentID/:transactionID/detail",
            element: <TransactionPage />,
          },
          {
            key: "gateway.refund",
            path: "transaction",
            element: <RefundTransactionPages />,
          },
        ],
      },

      { path: "*", element: <>404</> },
    ],
  },
];

const findRouteItemsPath = (items, path, parents = []) => {
  const paramRegex = /:[a-zA-Z0-9]+/g;
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item.path === "*") {
      break;
    }
    if (item?.children) {
      const result = findRouteItemsPath(item.children, path, item.key ? [...parents, item] : parents);
      if (result) {
        return result;
      }
    }
    if (item?.path !== undefined) {
      let matches;
      let pathRegex = "^/" + (parents.length ? parents.map((p) => (p.path ? p.path : p.key)).join("/") + "/" : "") + `${item.path}$`;
      while ((matches = paramRegex.exec(pathRegex)) !== null) {
        pathRegex = pathRegex.replace(new RegExp(matches[0], "gm"), "[a-zA-Z0-9-_]+");
      }
      if (path.match(pathRegex)) {
        return [...parents, item];
      }
    }
  }
  return null;
};

const findCurrentRoutePath = () => {
  return findRouteItemsPath(routeItems, window.location.pathname);
};

const router = createBrowserRouter(routeItems, {
  // basename: "/production-payplus-management/",
});

export default router;
export { routeItems, findCurrentRoutePath };
